(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-artists"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mm-artists-more]').forEach((btn) => {
  const root = btn.closest('.mm-artists');
  if (!root) return;
  const hasHidden = root.querySelectorAll('.mm-artists__card.is-hidden').length > 0;
  if (!hasHidden) {
    btn.style.display = 'none';
    return;
  }
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    root.querySelectorAll('.mm-artists__card.is-hidden').forEach((c) => c.classList.remove('is-hidden'));
    btn.style.display = 'none';
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-collection-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mm-cg]').forEach((root) => {
  const box = root.querySelector('[data-mm-cg-lightbox]');
  const bigImg = root.querySelector('[data-mm-cg-lightbox-img]');
  if (!box || !bigImg) return;
  const open = (src) => {
    bigImg.src = src;
    box.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    box.hidden = true;
    bigImg.src = '';
    document.body.style.overflow = '';
  };
  root.querySelectorAll('[data-mm-cg-open]').forEach((btn) => {
    btn.addEventListener('click', () => open(btn.getAttribute('data-full')));
  });
  root.querySelector('[data-mm-cg-close]').addEventListener('click', close);
  box.addEventListener('click', (e) => { if (e.target === box) close(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !box.hidden) close();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-gallery-carousel"] && !Shopify.designMode) return;
  try {
    
class MmCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-mm-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-mm-thumb]'));
    this.currentEl = this.querySelector('[data-mm-current]');
    this.thumbsWrap = this.querySelector('[data-mm-thumbs]');
    this.current = 0;
    this.total = this.slides.length;
    if (this.total === 0) return;

    const prev = this.querySelector('[data-mm-prev]');
    const next = this.querySelector('[data-mm-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.current - 1));
    if (next) next.addEventListener('click', () => this.go(this.current + 1));

    this.thumbs.forEach((t) => {
      t.addEventListener('click', () => this.go(parseInt(t.dataset.index, 10)));
    });

    const tprev = this.querySelector('[data-mm-tprev]');
    const tnext = this.querySelector('[data-mm-tnext]');
    if (tprev) tprev.addEventListener('click', () => this.scrollThumbs(-1));
    if (tnext) tnext.addEventListener('click', () => this.scrollThumbs(1));
  }

  go(index) {
    this.current = (index + this.total) % this.total;
    this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.current));
    this.thumbs.forEach((t, i) => t.classList.toggle('is-active', i === this.current));
    if (this.currentEl) this.currentEl.textContent = String(this.current + 1).padStart(2, '0');
    const active = this.thumbs[this.current];
    if (active && active.scrollIntoView) {
      active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  scrollThumbs(dir) {
    if (this.thumbsWrap) this.thumbsWrap.scrollBy({ left: dir * 320, behavior: 'smooth' });
  }
}
if (!customElements.get('mm-carousel')) {
  customElements.define('mm-carousel', MmCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-header"]) return;
  try {
    
class MmHeader extends HTMLElement {
  connectedCallback() {
    const burger = this.querySelector('[data-mm-burger]');
    const drawer = this.querySelector('[data-mm-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', () => {
        const open = drawer.hasAttribute('hidden');
        if (open) { drawer.removeAttribute('hidden'); } else { drawer.setAttribute('hidden', ''); }
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }
}
if (!customElements.get('mm-header')) {
  customElements.define('mm-header', MmHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-hero"] && !Shopify.designMode) return;
  try {
    
class MmHero extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-mm-track]');
    this.slides = Array.from(this.querySelectorAll('[data-mm-slide]'));
    this.current = 0;
    this.total = this.slides.length;
    this.currentEl = this.querySelector('[data-mm-current]');
    this.fillEl = this.querySelector('[data-mm-fill]');
    if (this.total <= 1) return;

    const prev = this.querySelector('[data-mm-prev]');
    const next = this.querySelector('[data-mm-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.current - 1));
    if (next) next.addEventListener('click', () => this.go(this.current + 1));

    // Set the initial progress fill for slide 1.
    if (this.fillEl) this.fillEl.style.width = (1 / this.total) * 100 + '%';

    if (this.dataset.autoplay === 'true') {
      const interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(() => this.go(this.current + 1), interval);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
    }
  }

  go(index) {
    this.current = (index + this.total) % this.total;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    if (this.currentEl) {
      this.currentEl.textContent = String(this.current + 1).padStart(2, '0');
    }
    if (this.fillEl) {
      this.fillEl.style.width = ((this.current + 1) / this.total) * 100 + '%';
    }
  }
}
if (!customElements.get('mm-hero')) {
  customElements.define('mm-hero', MmHero);
}
document.querySelectorAll('.mm-hero').forEach((el) => {
  if (el.tagName.toLowerCase() !== 'mm-hero') {
    Object.setPrototypeOf(el, MmHero.prototype);
    el.connectedCallback();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product-grid"] && !Shopify.designMode) return;
  try {
    
class MmProductGrid extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-mm-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-mm-panel]'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.index));
    });
  }
  activate(index) {
    this.tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.index === index));
    this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.index === index));
  }
}
if (!customElements.get('mm-product-grid')) {
  customElements.define('mm-product-grid', MmProductGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mm-inquire]');
  if (!root) return;
  function open() {
    root.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    root.hidden = true;
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-mm-inquire-open]').forEach(function (b) {
    b.addEventListener('click', open);
  });
  root.querySelectorAll('[data-mm-inquire-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
  if (root.querySelector('.mm-inq__success') || /[?&]contact_posted=true/.test(location.search)) {
    open();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
